<ng-template #innerTemplate>
  <ng-content></ng-content>
</ng-template>
